

export default {
  name: 'HeaderAccountButton',
  methods: {
    followLink(slug) {
      this.$router.push(slug);
      this.$nextTick(() => {
        this.$emit('close');
      });
    },
    singOut() {
      this.$emit('close');
      this.$auth.logout();
    },
  },
};
